export abstract class AbstractDirectoryPreFaxCallback<T> {
    protected model: T;

    public constructor(model: T) {
        this.model = model;
    }

    public abstract trigger(): Promise<void>;
}
